<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>신청서 종류</v-list-item-title>
          <v-list-item-content> {{ applTitle }} </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청시작월</v-list-item-title>
          <v-list-item-content>
            {{ sYmd.slice(0, 4) + '-' + sYmd.slice(4) }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청종료월</v-list-item-title>
          <v-list-item-content>
            {{ eYmd.slice(0, 4) + '-' + eYmd.slice(4) }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>주소</v-list-item-title>
          <v-list-item-content> {{ address }} </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>용도</v-list-item-title>
          <v-list-item-subtitle> {{ purpose }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>제출처</v-list-item-title>
          <v-list-item-content> {{ submitOffice }} </v-list-item-content>
        </v-list-item>
        <v-list-item   v-show="emailAddrShow">
          <v-list-item-title>메일주소</v-list-item-title>
          <v-list-item-content> {{ emailAddr }} </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기타</v-list-item-title>
          <v-list-item-content> {{ etc }} </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getReCertAppList, getReCertAppDetail } from '@/api/workStatus';
import { mapMutations } from 'vuex';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    applTitle: '',
    applCd: '',
    address: '',
    period: '',
    etc: '',
    purpose: '',
    purposeCd: '',
    submitOffice: '',
    sYmd: '',
    eYmd: '',
    emailAddr: '',
    emailAddrShow: false,
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },

  async created() {
    let response = await getReCertAppList(this.appInfoParam);
    if (response.data.data[0] !== undefined) {
      this.applTitle = response.data.data[0].applTitle;
      this.address = response.data.data[0].address;
    }

    response = await getReCertAppDetail(this.appInfoParam);
    this.purpose = response.data.data.purpose;
    this.submitOffice = response.data.data.submitOffice;
    this.etc = response.data.data.etc;
    this.sYmd = response.data.data.sYmd;
    this.eYmd = response.data.data.eYmd;
    this.emailAddr = response.data.data.emailAddr;

    if(this.emailAddr !== null)
    {
      this.emailAddrShow = true;
    }


    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
